<template>
    <div class="tabContent1 mb-5">
        <div class="">
            <h4>Start Date</h4>
            <h5>{{start}}</h5>
        </div>

        <div v-if="type === 'competition'" class="">
            <h4>End Date</h4>
            <h5>{{end}}</h5>
        </div>
        <div v-if="type === 'competition'" class="">
            <h4>Start Time</h4>
            <h5>{{startTime.slice(0,5)}} GMT</h5>
        </div>
        <div v-if="type === 'competition'" class="">
            <h4>Duration</h4>
            <h5>{{durationInfo}}</h5>
        </div>
        <vue-countdown v-if="this.startCountflag"
                       :time="dd??dd"
                       @start="onCountdownStart"
                       @end="onCountdownEnd"
                       v-slot="{ days, hours, minutes, seconds }">
            <div  class=" d-flex gap-3">

                <div class="minsCss text-center">
                    <h5>{{hours > 10 ? hours : '0'+ hours}}</h5>
                    <span>Hours</span>
                </div>
                <div class="columnCss">:</div>

                <div class="minsCss text-center">
                    <h5>{{minutes >= 10 ? minutes : '0'+ minutes}}</h5>
                    <span>Minutes</span>
                </div>
                <div class="columnCss">:</div>

                <div class="minsCss text-center">
                    <h5>{{seconds >= 10 ? seconds : '0'+ seconds}}</h5>
                    <span>Seconds</span>
                </div>
            </div>
        </vue-countdown>
    </div>
</template>

<script>
    import VueCountdown from '@chenfengyuan/vue-countdown';
    import moment from 'moment';

    export default {
        name: 'pageInformation-component',
        components: {VueCountdown},
        data() {
            return {
                start: null,
                end: null,
                durationInfo: null,
                dd: null,
                time: null,
                startCountflag: false,
            }
        },
        async mounted() {

            if((this.type === 'training') || (!this.is_submited) && ( !this.is_user_submit)){

                this.time = moment(this.startDate).format('YYYY-MM-DD') + 'T' + this.startTime;
                let endTime = moment(this.endDate).format('YYYY-MM-DD') + 'T' + this.endTime;

                let startedAt = moment(this.started_at).format('YYYY-MM-DDTHH:mm:ss');

                let startTime = moment.duration(moment().diff(this.time)).as('minutes');
                let startEnd = moment.duration(moment(endTime).diff(moment())).as('minutes');
                let startAtTime = moment.duration(moment().diff(moment(startedAt))).as('minutes');
                let now = moment.utc().format('YYYY-MM-DDTHH:mm:ss');

                if ((this.time < now) && (now < endTime)) {
                    let diffTime = moment.duration(moment(endTime).diff(moment(startedAt))).asMinutes();

                    if(this.duration !== null){
                        if (diffTime >= this.duration) {
                            let diff = moment.duration(moment(now).diff(moment(startedAt))).asMinutes() < 0 ? 0 : moment.duration(moment(now).diff(moment(startedAt))).asMinutes();

                            console.log({diff})

                            if (diff > this.duration){
                                console.log("eventTimeout")
                                this.$emit('eventTimeout');
                            }

                            else
                                this.dd = ((this.duration) - diff) * 60000 ;
                        } else if (diffTime < this.duration) {
                            let diffD = moment.duration(moment(endTime).diff(moment(now))).asMinutes();
                            this.dd = (diffD) * 60000
                        }
                    }

                } else {
                    await this.$store.dispatch('setAnswersFlag', false);
                    await this.$store.dispatch('setErrorModal', true);
                    await this.$store.dispatch('setErrorMessage', this.type.charAt(0).toUpperCase() + this.type.slice(1) + ' time ended');
                    clearInterval(this.intervalID);
                    setTimeout(async () => {
                        await this.$router.push({path:'/' + this.backeUrl})
                    }, 1000)

                }
                this.start = moment(this.startDate).format('D MMM YYYY');
                this.end = moment(this.endDate).format('D MMM YYYY');
                this.durationInfo = moment.duration(this.duration, 'minutes').humanize();
                if(this.duration !== null) {
                    setTimeout(() => {
                        this.startCountflag = true;
                    }, 1000)
                }

            }else{
                await this.$store.dispatch('setAnswersFlag', false);
                await this.$store.dispatch('setErrorModal', true);
                await this.$store.dispatch('setErrorMessage', this.type.charAt(0).toUpperCase() + this.type.slice(1) + 'is submited before');
                clearInterval(this.intervalID);
                console.log('back url => ',this.backeUrl)
                setTimeout(async () => {
                    await this.$router.push({path:'/' + this.backeUrl})
                }, 1000)

            }

        },
        props: ['type', 'startDate', 'endDate', 'startTime', 'endTime', 'duration', 'started_at', 'is_submited', 'is_user_submit', 'backeUrl'],
        methods: {
            onCountdownStart() {
                console.log('onCountdownStart')
            },
            async onCountdownEnd() {
                this.$emit('eventEnded');
            }
        }
    }
</script>

<style scoped>

    .minsCss h5 {
        font-size: 29px;
    }

    .minsCss {
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 75px;
        height: 75px;
        border-radius: 5px;
    }

    .columnCss {
        color: #E95626;
        font-size: 44px;
        font-weight: bold;
    }

    .daysCss h5 {
        font-size: 29px;
    }

    .daysCss {
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 70px;
        height: 75px;
        border-radius: 5px;
    }

    .tabContent1 {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        overflow-y: auto;
        padding: 15px;
        height: 12vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
        gap: 10px;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px)  {
        .tabContent1{
            height: 19vh;
        }
    }

    @media only screen and (max-width: 1170px) and (min-width: 1024px){
        .tabContent1{
            height: 20vh;
        }
    }

</style>